import React, { PropsWithChildren } from "react";

type CalculatorSectionProps = PropsWithChildren<{
  counter?: number;
  title?: string;
  description?: string;
  fullWidth?: boolean;
}>;

export function CalculatorSection({
  counter,
  children,
  title,
  description,
  fullWidth
}: CalculatorSectionProps) {
  return (
    <fieldset className="calculatorRegion pt-4 pb-4 px-1 px-md-0">
      <div className="d-flex flex-column flex-md-row px-4 px-md-5">
        {!fullWidth && <div className="calculatorCounter mb-1 mr-md-5">
          {counter && (
            <div className="rounded bg-ecru text-center py-1 text-larger mb-3">
              {counter}
            </div>
          )}
        </div>}
        <div className="w-100 pt-md-2">
          {title && (
            <legend
              className="text-primary mb-2 h4 h3-md"
              dangerouslySetInnerHTML={{ __html: title }}
            ></legend>
          )}
          {description && (
            <p
              className="mt-1 text-medium mb-4 last-child-no-margin"
              dangerouslySetInnerHTML={{ __html: description }}
            ></p>
          )}
          <div className="w-100 pt-md-2">{children}</div>
        </div>
      </div>
    </fieldset>
  );
}
